import bind from '@/search_profiles/bind'

bind()
